import { useQuery } from '@tanstack/react-query';

import { transportationApi } from '~endpoints/Transportation';
import { pointToPointTicketKeys } from '~queryKeys/transportation/pointToPointTicket';

type Type = Parameters<typeof transportationApi.v1.RailEurope.getPopularPlaceList>['0'];

export async function fetchPopularPlaceList(type: Type) {
  return transportationApi.v1.RailEurope.getPopularPlaceList(type);
}

const usePopularPlaceList = (type: Type, options?: Record<string, unknown>) => {
  return useQuery({
    queryKey: pointToPointTicketKeys.getPopularPlaceList(type),
    queryFn: () => fetchPopularPlaceList(type).then((res) => res.data),
    ...options,
  });
};

export default usePopularPlaceList;
